import script from "./QuestionDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionDrawer.vue?vue&type=script&setup=true&lang=js"

import "./QuestionDrawer.vue?vue&type=style&index=0&id=2d3e1206&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d3e1206"]])

export default __exports__